module.exports = __webpack_public_path__ + "static/media/gameplay_bg_05.4842661e.jpg";